const CLIENTS = ['prisaude', 'solides', 'limer']
const DEFAULT_CLIENT = 'limer'

/**
 * Configuração centralizada de brand por cliente (hostname).
 * Para adicionar ou ajustar um cliente, edite apenas este arquivo.
 */
const brands = {
  limer: {
    id: 'limer',
    hostnameMatch: 'limer',
    title: 'Limer - Saúde Ocupacional',
    favicon: 'favicon-limer.ico',
    colors: {
      loginTheme: '#006bf2',
      textLoginTheme: '#C099FF',
    },
    logos: {
      main: '/logo-novo.png',
      icon: null,
    },
    features: {
      showMedicoButton: true,
      showWhatsappButton: true,
    },
  },
  prisaude: {
    id: 'prisaude',
    hostnameMatch: 'prisaude',
    title: 'Unimed - Gestão Ocupacional',
    favicon: 'favicon-unimed.ico',
    colors: {
      loginTheme: '#00985E',
      textLoginTheme: '#C099FF',
    },
    logos: {
      main: '/logo-unimed.webp',
      icon: '/icone-unimed.png',
    },
    features: {
      showMedicoButton: true,
      showWhatsappButton: true,
    },
  },
  solides: {
    id: 'solides',
    hostnameMatch: 'solides',
    title: 'Sólides - Gestão Ocupacional',
    favicon: 'favicon-solides.ico',
    colors: {
      loginTheme: '#80297C',
      textLoginTheme: '#c271beff',
    },
    logos: {
      main: '/logo-solides.png',
      icon: '/icone-solides.png',
    },
    features: {
      showMedicoButton: false,
      showWhatsappButton: false,
    },
  },
}

function getCurrentClient(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  return CLIENTS.find(client => hostname.includes(client)) || DEFAULT_CLIENT
}

function getBrand(client = getCurrentClient()) {
  return brands[client] || brands[DEFAULT_CLIENT]
}

function getBrandHtmlInitScript() {
  const settings = CLIENTS.map(id => ({
    match: brands[id].hostnameMatch,
    title: brands[id].title,
    icon: brands[id].favicon,
  }))

  return `(function () {
  const hostname = window.location.hostname;
  const settings = ${JSON.stringify(settings)};
  const found = settings.find(item => hostname.includes(item.match)) || settings[0];
  document.title = found.title;
  document.querySelector('#dynamic-favicon').href = found.icon;
})();`
}

module.exports = {
  CLIENTS,
  DEFAULT_CLIENT,
  brands,
  getCurrentClient,
  getBrand,
  getBrandHtmlInitScript,
}
